import React, { useState, useEffect } from 'react'
import { DigitalVaultBinView } from '../../views';
import { CacheStorageService, DigitalVaultDocumentService, DigitalVaultService, LocalStorageService } from '../../../services';
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

const DigitalVaultBinAction = (props) => {
    const {
        toggleCompletedRequesting,
        toggleLoadingRequesting,
        toggleErrorRequesting,
        t
    } = props;

    const [isLoading, setIsLoading] = useState(true);
    const [companies, setCompanies] = useState([]);
    const [selectedCompanyId, setSelectedCompanyId] = useState('0');
    const [documents, setDocuments] = useState([]);
    const [selectedDocument, setSelectedDocument] = useState(null);

    const [viewDeleteDialog, setViewDeleteDialog] = useState(false);

    const url = process.env.REACT_APP_MIFIRMA_API;
    const localStorageService = new LocalStorageService();
    const token = localStorageService.getLocalStorageItem("token").idToken;
    const timezone = localStorageService.getLocalStorageItem("timezone");
    const digitalVaultService = new DigitalVaultService(url);
    const digitalVaultDocumentService = new DigitalVaultDocumentService(url);
    const cacheService = new CacheStorageService();

    const loadDocuments = async (deleteCache = false) => {
        setIsLoading(true);

        try {
            if (deleteCache) await cacheService.deleteUrlFromCache("/digital-vault-bin")
            const response = await digitalVaultService.getDeletedDocuments(token, timezone);

            if (response.statusCode == 200 && response.data) {
                setDocuments(response.data.documents);
                let companyOptions = response.data.companies;
                companyOptions.sort((a, b) => a.companyName.toLowerCase().localeCompare(b.companyName.toLowerCase()))
                companyOptions = [{ id: '0', companyName: t("digitalVaultBinView.all.companies")}, ...companyOptions]
                setCompanies(companyOptions);
            } else {
                throw new Error(response.data.message || t("digitalVaultBinView.errors.general"))
            }
            setIsLoading(false);
        } catch (e) {
            toggleErrorRequesting(true, e.message, 4000, true)
        }
    }

    const updateStatus = async (status, ids) => {
        if (!ids && (!selectedDocument || !selectedDocument.id)) return;

        const errorMsg = `${t("digitalVaultBinView.errors.get.document")} ${status.toLowerCase()} ${ids ? t("digitalVaultBinView.errors.documents"): t("digitalVaultBinView.errors.document")}.`
        setViewDeleteDialog(false);

        toggleLoadingRequesting(true);
        try {
            const response = await digitalVaultDocumentService.updateDocumentStatus(ids || selectedDocument.id, status, token);
            if (response.statusCode == 200) {
                toggleLoadingRequesting(false);
                toggleCompletedRequesting(true);
                setTimeout(() => {
                    toggleCompletedRequesting(false);
                    loadDocuments(true);
                }, 4000);
            }
            else {
                throw new Error(response.message || errorMsg)
            }
        } catch (e) {
            toggleErrorRequesting(true, e.message, 4000, false);
        } finally {
            toggleLoadingRequesting(false);
        }
    }

    const deleteDocument = () => updateStatus("Eliminar")
    const restoreDocument = () => updateStatus("Restaurar")
    const deleteMany = (ids) => updateStatus("Eliminar", ids)

    useEffect(() => {
        loadDocuments();
        return () => {
            cacheService.deleteUrlFromCache("/digital-vault-bin")
        }
    }, [])

    return (
        <DigitalVaultBinView
            isLoading={isLoading}
            companies={companies}
            selectedCompanyId={selectedCompanyId}
            setSelectedCompanyId={setSelectedCompanyId}
            documents={documents}
            selectedDocument={selectedDocument}
            setSelectedDocument={setSelectedDocument}
            deleteMany={deleteMany}
            deleteDocument={deleteDocument}
            restoreDocument={restoreDocument}
            viewDeleteDialog={viewDeleteDialog}
            setViewDeleteDialog={setViewDeleteDialog}
        />
    )
}

export default withRouter(withTranslation()(DigitalVaultBinAction));